<div class="media-selector-general">
  <div class="media-selector-general__step-text bold">
    {{ 'TRANS__IMAGE_SELECTOR__STEP_1_HEADLINE' | translate }}
  </div>

  <div
    class="media-selector-general__image-drop-zone"
    (drop)="onDropFile($event)"
    (dragover)="onDragOverFile($event)"
  >
    <app-media-selector-selected-files
      class="full-width"
      [files]="files"
      (fileDeleted)="handleFileDeleted($event)"
      [showSelected]="false"
      [text]="'TRANS__IMAGE_SELECTOR__DRAG_AND_DROP_FILE_HERE'"
      [_snackBar]="snackBarSignal"
      [imageIdField]="'image_id'"
    ></app-media-selector-selected-files>

    @if (cameraOpen) {
      <div class="media-selector-general__cameraOpen">
        <h5 class="bold">
          {{ 'TRANS__IMAGE_SELECTOR__NEW_IMAGE_CAMERA' | translate }}
        </h5>

        <app-media-upload-camera
          (uploadCameraImages)="uploadFiles($event)"
          [fileAccept]="fileAccept"
        ></app-media-upload-camera>
      </div>
    }

    @if (selectImg && parentMedia.length) {
      <div class="full-width">
        <app-media-selector-selected-files
          class="full-width"
          [selectedFiles]="files"
          [files]="parentMedia"
          [showSelected]="true"
          [text]="'TRANS__IMAGE_SELECTOR__CHOOSE_OBJECT_IMAGE'"
          [imageIdField]="'image_id'"
          (itemSelected)="onSelectedItem($event)"
        ></app-media-selector-selected-files>
      </div>
    }
  </div>

  <div class="media-selector-general__buttons">
    <input
      #fileInput
      type="file"
      (change)="onFileSelect($event)"
      id="uploadFiles"
      [attr.multiple]="multipleFiles? 'multiple' : undefined"
      [attr.accept]="fileAccept"
    >

    <button
      mat-stroked-button
      type="button"
      color="primary"
      (click)="uploadFile(fileInput)"
    >
      <i class="icon-upload"></i>

      @if (computer) {
        @if (multipleFiles) {
          <span class="bold uppercase">
            {{ uploadInfo.text_upload | translate }}
          </span>
        }
        @else {
          <span class="bold uppercase">
            {{ uploadInfo.text_upload_single | translate }}
          </span>
        }
      }
      @else {
        @if (multipleFiles) {
          <span class="bold uppercase">
            {{ uploadInfo.text_upload_tablet | translate }}
          </span>
        }
        @else {
          <span class="bold uppercase">
            {{ uploadInfo.text_upload_single_tablet | translate }}
          </span>
        }
      }
    </button>

    @if (computer && fromCamera) {
      <button
        color="primary"
        type="button"
        (click)="openCamera()"
        [ngClass]="{'active':cameraOpen}"
      >
        <i class="icon-camera"></i>

        <span class="bold uppercase">
          {{ uploadInfo.text_from_camera | translate }}
        </span>
      </button>
    }
  </div>

  @if (selectFromParent && parentMedia.length) {
    <div class="media-selector-general__buttons">
      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="selectFiles()"
        [ngClass]="{'active':selectImg}"
      >
        <i class="icon-select1"></i>

        <span class="bold uppercase">
          {{ uploadInfo.text_select_from_parent | translate }}
        </span>
      </button>
    </div>
  }
</div>
